/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import CountUp from 'react-countup';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertToRupiah, MONTH } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@sims/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Pembayaran';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'pembayaran';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_kelas, set_data_kelas] = useState(null);
    const [data_tahun, set_data_tahun] = useState(null);
    const [data_pembayaran_bulan, set_data_pembayaran_bulan] = useState(0);
    const [data_pembayaran_tahun, set_data_pembayaran_tahun] = useState(0);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [filter_kelas, set_filter_kelas] = useState('')
    const [filter_bulan, set_filter_bulan] = useState('juli')
    const [filter_tahun, set_filter_tahun] = useState('')

    const [nis, set_nis] = useState('')
    const [nama, set_nama] = useState('')
    const [kelas, set_kelas] = useState('')
    const [harga, set_harga] = useState('')
    const [bulan, set_bulan] = useState('')
    const [tahun, set_tahun] = useState('')
    const [data_bulan, set_data_bulan] = useState([
        {
            bulan: "juli",
        },
        { 
            bulan: "agustus",
        },
        { 
            bulan: "september",
        },
        { 
            bulan: "oktober",
        },
        { 
            bulan: "november",
        },
        { 
            bulan: "desember",
        },
        { 
            bulan: "januari",
        },
        { 
            bulan: "februari",
        },
        { 
            bulan: "maret",
        },
        { 
            bulan: "april",
        },
        { 
            bulan: "mei",
        },
        { 
            bulan: "juni"
        }
    ])
    const [card_number, set_card_number] = useState('5264 2210 3887 4659')
    const [card_exp_month, set_card_exp_month] = useState('12')
    const [card_exp_year, set_card_exp_year] = useState('2025')
    const [card_cvv, set_card_cvv] = useState('123')
    const [redirect_url, set_redirect_url] = useState('')
    const [order_id, set_order_id] = useState('')
    const [response, set_response] = useState('');
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/pembayaran/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&kelas=' + filter_kelas
            + '&bulan=' + filter_bulan
            + '&tahun=' + filter_tahun
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_kelas = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_kelas_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kelas', response.data)
            if(response.data.result == 'success'){
                set_data_kelas(response.data.data)
                set_filter_kelas(response.data.data.list[0].kelas)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_tahun = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_tahun_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read tahun', response.data)
            if(response.data.result == 'success'){
                set_data_tahun(response.data.data)
                set_filter_tahun(response.data.data.list[0].tahun)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_pembayaran_bulan = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/pembayaran/get__________?action=read_${request_params}_bulan`
            + '&bamboo_user=' + bambooUserParams
            + '&bulan=' + filter_bulan
            + '&tahun=' + filter_tahun
        , 
		).then((response) => {
            console_dev('response read tahun', response.data)
            if(response.data.result == 'success'){
                set_data_pembayaran_bulan(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_pembayaran_tahun = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/pembayaran/get__________?action=read_${request_params}_tahun`
            + '&bamboo_user=' + bambooUserParams
            + '&bulan=' + filter_bulan
            + '&tahun=' + filter_tahun
        , 
		).then((response) => {
            console_dev('response read tahun', response.data)
            if(response.data.result == 'success'){
                set_data_pembayaran_tahun(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`sims/pembayaran/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&kelas=' + filter_kelas
                + '&bulan=' + filter_bulan
                + '&tahun=' + filter_tahun
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "sims/pembayaran/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev('response uploads', response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('sims/pembayaran/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            card_number: card_number,
            card_exp_month: card_exp_month,
            card_exp_year: card_exp_year,
            card_cvv: card_cvv,
            order_id: order_id,
            nis: nis,
            nama: nama,
            kelas: kelas,
            harga: harga,
            bulan: bulan,
            tahun: tahun,
		}).then((response) => {
            console_dev('response upload post', response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')       
                // update state ------------------
                set_test('')
                set_card_number('')
                set_card_exp_month('')
                set_card_exp_year('')
                set_card_cvv('')
                set_redirect_url('')
                set_order_id('')
                set_nama('')
                set_kelas('')
                set_harga('')
                set_bulan('')
                set_tahun('')
			}else if(response.data.result == 'auth'){
                set_redirect_url(response.data.data.redirect_url)
                set_order_id(response.data.data.order_id)
			}else if(response.data.result == 'error'){
                error(response.data.title)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                // _read(1, storage_bamboo)
                _read_kelas(storage_bamboo)
                _read_tahun(storage_bamboo)

            }

        }else{

            error('User Not Found')
        
        }

    }
    
    const _STORAGE_USER_ONLY_READ = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }

    const _STORAGE_USER_ONLY_READ_PAYMENT = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _read_pembayaran_bulan(storage_bamboo)
                _read_pembayaran_tahun(storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            if(filter_kelas && filter_bulan && filter_tahun){
                _STORAGE_USER_ONLY_READ()
                _STORAGE_USER_ONLY_READ_PAYMENT()
            }else{
                _STORAGE_USER()
            }
        }

    }, [refresh, search])

    useEffect(() => {
        
        if(filter_kelas && filter_bulan && filter_tahun){
            _STORAGE_USER_ONLY_READ()
            _STORAGE_USER_ONLY_READ_PAYMENT()
        }

    }, [filter_kelas])

    useEffect(() => {
        
        if(filter_kelas && filter_bulan && filter_tahun){
            _STORAGE_USER_ONLY_READ()
            _STORAGE_USER_ONLY_READ_PAYMENT()
        }

    }, [filter_bulan])

    useEffect(() => {

        if(filter_kelas && filter_bulan && filter_tahun){
            _STORAGE_USER_ONLY_READ()
            _STORAGE_USER_ONLY_READ_PAYMENT()
        }

    }, [filter_tahun])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div>
                                                <div className="_row_auto _push_b_g" style={{marginLeft: -10, marginRight: -10}}>
                                                    <div className="_column_auto">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Server Pembayaran</span>
                                                        </div>
                                                        <div className="_fmc_credit_card">
                                                            <div className="_card_number">
                                                                <p>Card Number</p>
                                                                <div className="_relative _push_b_d">
                                                                    <div className="_e_input">
                                                                        <div className="_row _center_align">
                                                                            <div className="_column">
                                                                                <CurrencyFormat
                                                                                    style={{fontSize: 20}} 
                                                                                    placeholder="2222 4444 6666 8888"
                                                                                    value={card_number} 
                                                                                    thousandSeparator={true} 
                                                                                    prefix={''}
                                                                                    format="#### #### #### ####"
                                                                                    onValueChange={(e) => {
                                                                                        if(e.value.length < 17){
                                                                                            set_card_number(e.value)
                                                                                        }else{
                                                                                            error('Max Length')
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <p>Expiry</p>
                                                            <div className="_row _center_align _push_t_s">
                                                                <div className="_column">
                                                                    <div className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13}}>
                                                                            Month
                                                                        </p>
                                                                        <div className="_e_input">
                                                                            <input 
                                                                                style={{fontSize: 20}} 
                                                                                minLength={2}
                                                                                placeholder="01"
                                                                                type={'text'} 
                                                                                onChange={e => set_card_exp_month(e.target.value)}
                                                                                value={card_exp_month}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13}}>
                                                                            Year
                                                                        </p>
                                                                        <div className="_e_input">
                                                                            <input 
                                                                                style={{fontSize: 20}} 
                                                                                minLength={4}
                                                                                placeholder="25"
                                                                                type={'text'} 
                                                                                onChange={e => set_card_exp_year(e.target.value)}
                                                                                value={card_exp_year}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <p>CVV</p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    style={{fontSize: 20}} 
                                                                    minLength={3}
                                                                    placeholder="123"
                                                                    type={'text'} 
                                                                    onChange={e => set_card_cvv(e.target.value)}
                                                                    value={card_cvv}
                                                                />
                                                            </div>
                                                            <div className="_row _center_align _push_t_d _cl_smooth_0">
                                                                <ion-icon name="card-outline" style={{fontSize: 26, marginBottom: 0, marginRight: 8}}></ion-icon>
                                                                Powered By Mitrans
                                                            </div>
                                                        </div>

                                                        <div onClick={() => {
                                                            _uploads_post(`insert_${request_params}_credit`)
                                                            // _uploads(`insert_${request_params}`)
                                                        }} className="_btn _cursor_pointer _push_r_m _push_t_d">
                                                            Pay Now
                                                        </div>
                                                        {
                                                            redirect_url.length > 0 &&
                                                            <div className="_fmc_overlay">
                                                                <div className="_fmc_overlay_navbar">
                                                                    <div className="_row _center_align">
                                                                        <div className="_column">
                                                                            <p className="_font_size_18px">Authentication</p>
                                                                        </div>
                                                                        {/* <div onClick={() => {
                                                                            set_redirect_url('')
                                                                            set_order_id('')
                                                                        }} className="_push_l_d _btn _cursor_pointer">
                                                                            Keluar
                                                                        </div> */}
                                                                        <div onClick={() => {
                                                                            _uploads_post(`${request_params}_status`)
                                                                        }} className="_push_l_d _btn _cursor_pointer">
                                                                            Selesaikan
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_fmc_overlay_content" style={{marginLeft: -20, marginRight: -20}}>
                                                                    <div className="_container">
                                                                        <div className="_row_auto">
                                                                            <div className="_column_auto">
                                                                                <div className="_push_b_d">
                                                                                    <div className="_heading_bold _push_b_d">
                                                                                        Cloud : <span className="_grey">Keamanan Pembayaran 3DS</span>
                                                                                    </div>
                                                                                    <p className="_push_b_m">Setelah anda mengisi password lalu tekan <b>OK</b>, Jika berhasil maka akan muncul pesan <b>"Card is authenticated." </b>Lalu tekan tombol <b>"Selesaikan"</b></p>
                                                                                    <p className="_push_b_m">Jangan tekan tombol keluar jika anda sudah melakukan pembayaran, karena data pembayaran anda tidak akan ditambahkan kedatabase.</p>
                                                                                    <p className="_push_b_m">Jika anda ingin keluar sebelum melakukan pembayaran, maka pembayaran akan dibatalkan.</p>
                                                                                    <div onClick={() => {
                                                                                        set_redirect_url('')
                                                                                        set_order_id('')
                                                                                    }} className="_btn _cursor_pointer">
                                                                                        Keluar
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="_column_auto">
                                                                                <div className="_push_b_l">
                                                                                    <iframe style={{height: 500, borderRadius: 8, borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', overflow: 'hidden'}} src={redirect_url}></iframe>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="_column_auto">
                                                        <div className="_relative _push_b_d _push_t_m">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                NIS
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_nis(e.target.value)}
                                                                    value={nis}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Nama
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_nama(e.target.value)}
                                                                    value={nama}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Kelas
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_kelas(e.target.value)}
                                                                            value={kelas}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_kelas'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_kelas')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_kelas' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_kelas' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_kelas' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_kelas && data_kelas.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {
                                                                                                set_kelas(item.kelas)
                                                                                                set_harga(item.spp)
                                                                                            }} className="_item" style={{backgroundColor: kelas === item.kelas ? '#eee' : null}}>{decode(item.kelas)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                SPP
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_push_r_t">
                                                                        Rp.
                                                                    </div>
                                                                    <div className="_column">
                                                                        <CurrencyFormat 
                                                                            value={harga} 
                                                                            thousandSeparator={true} 
                                                                            prefix={''}
                                                                            onValueChange={(e) => {
                                                                                if(e.value.length < 10){
                                                                                    set_harga(e.value)
                                                                                }else{
                                                                                    set_harga('')
                                                                                    error('Max Length')
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Bulan
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_bulan(e.target.value)}
                                                                            value={bulan}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_bulan'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_bulan')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_bulan' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_bulan' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_bulan' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    <div onClick={() => {set_bulan('Juli')}} className="_item" style={{backgroundColor: bulan === 'Juli' ? '#eee' : null}}>Juli</div>
                                                                                    <div onClick={() => {set_bulan('Agustus')}} className="_item" style={{backgroundColor: bulan === 'Agustus' ? '#eee' : null}}>Agustus</div>
                                                                                    <div onClick={() => {set_bulan('September')}} className="_item" style={{backgroundColor: bulan === 'September' ? '#eee' : null}}>September</div>
                                                                                    <div onClick={() => {set_bulan('Oktober')}} className="_item" style={{backgroundColor: bulan === 'Oktober' ? '#eee' : null}}>Oktober</div>
                                                                                    <div onClick={() => {set_bulan('November')}} className="_item" style={{backgroundColor: bulan === 'November' ? '#eee' : null}}>November</div>
                                                                                    <div onClick={() => {set_bulan('Desember')}} className="_item" style={{backgroundColor: bulan === 'Desember' ? '#eee' : null}}>Desember</div>
                                                                                    <div onClick={() => {set_bulan('Januari')}} className="_item" style={{backgroundColor: bulan === 'Januari' ? '#eee' : null}}>Januari</div>
                                                                                    <div onClick={() => {set_bulan('Februari')}} className="_item" style={{backgroundColor: bulan === 'Februari' ? '#eee' : null}}>Februari</div>
                                                                                    <div onClick={() => {set_bulan('Maret')}} className="_item" style={{backgroundColor: bulan === 'Maret' ? '#eee' : null}}>Maret</div>
                                                                                    <div onClick={() => {set_bulan('April')}} className="_item" style={{backgroundColor: bulan === 'April' ? '#eee' : null}}>April</div>
                                                                                    <div onClick={() => {set_bulan('Mei')}} className="_item" style={{backgroundColor: bulan === 'Mei' ? '#eee' : null}}>Mei</div>
                                                                                    <div onClick={() => {set_bulan('Juni')}} className="_item" style={{backgroundColor: bulan === 'Juni' ? '#eee' : null}}>Juni</div>
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Tahun
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_tahun(e.target.value)}
                                                                            value={tahun}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_tahun'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_tahun')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_tahun' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_tahun' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_tahun' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_tahun && data_tahun.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {set_tahun(item.tahun)}} className="_item" style={{backgroundColor: tahun === item.tahun ? '#eee' : null}}>{decode(item.tahun)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                                    
                                                        {/* <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Sub Dropdown
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            // onChange={e => set_input(e.target.value)}
                                                                            // value={input}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'sub_dropdown'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('sub_dropdown')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'sub_dropdown' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'sub_dropdown' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'sub_dropdown' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    <div onClick={() => {set_input('Input')}} className="_item" style={{backgroundColor: input === 'Input' ? '#eee' : null}}>Input</div>
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        {/* <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Input
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_push_r_t">
                                                                        Rp.
                                                                    </div>
                                                                    <div className="_column">
                                                                        <CurrencyFormat 
                                                                            value={input} 
                                                                            thousandSeparator={true} 
                                                                            prefix={''}
                                                                            onValueChange={(e) => {
                                                                                if(e.value.length < 10){
                                                                                    set_input(e.value)
                                                                                }else{
                                                                                    set_input('')
                                                                                    error('Max Length')
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        {/* <p className="_push_b_m _cl_smooth_0">Description</p> */}
                                                        {/* <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                            <div className="_e_input">
                                                                <input
                                                                    className="custom-file-input" 
                                                                    type="file"
                                                                    name="file"
                                                                    placeholder=""
                                                                    onChange={_files}
                                                                />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`delete_${request_params}`)
                                                // _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Detail</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Detail Pembayaran</span>
                                            </div>
                                            {
                                                response &&
                                                <div>
                                                    <p className="_push_b_t _cl_smooth_0">Order ID</p>
                                                    <p className="_font_size_20px _push_b_m">{response.order_id}</p>
                                                    <p className="_push_b_t _cl_smooth_0">Transaksi ID</p>
                                                    <p className="_font_size_20px _push_b_m">{response.transaction_id}</p>
                                                    <p className="_push_b_t _cl_smooth_0">Waktu Transaksi</p>
                                                    <p className="_font_size_20px _push_b_m">{response.transaction_time}</p>
                                                    <p className="_push_b_t _cl_smooth_0">Tipe Pembayaran</p>
                                                    <p className="_font_size_20px _push_b_m">{response.payment_type}</p>
                                                    <p className="_push_b_t _cl_smooth_0">Tipe Kartu</p>
                                                    <p className="_font_size_20px _push_b_m">{response.card_type}</p>
                                                    
                                                </div>
                                            }
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}

            <div className="_row_auto _center_align" style={{marginLeft: -10, marginRight: -10}}>
                <div className="_row _center_align">
                    <div className="_push_r_m" style={{marginLeft: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_kelas'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_kelas')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_kelas' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_kelas.length > 0 ? filter_kelas : 'Kelas'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_kelas' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_kelas' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_kelas && data_kelas.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_kelas(item.kelas)}} className="_item" style={{backgroundColor: filter_kelas === item.kelas ? '#eee' : null}}>{item.kelas}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                    <div style={{marginRight: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_bulan'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_bulan')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_bulan' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column _capitalize">
                                        {filter_bulan.length > 0 ? filter_bulan : 'Bulan'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_bulan' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_bulan' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_bulan && data_bulan.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_bulan(item.bulan)}} className="_item _capitalize" style={{backgroundColor: filter_bulan === item.bulan ? '#eee' : null}}>{item.bulan}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                    <div style={{marginRight: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_tahun'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_tahun')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_tahun' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_tahun.length > 0 ? filter_tahun : 'Tahun'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_tahun' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_tahun' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_tahun && data_tahun.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_tahun(item.tahun)}} className="_item" style={{backgroundColor: filter_tahun === item.tahun ? '#eee' : null}}>{item.tahun}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                </div>
                <div className="_column_auto">
                    {/*  Search -------------------------------------------------------------------- */}
                    <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                        <div className="_row _center_align">
                            <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                            <div className="_column">
                                <input 
                                    placeholder="Cari NIS" 
                                    onChange={e => set_search(e.target.value)}
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {/*  End Search ---------------------------------------------------------------- */}
                </div>
            </div>

            <div className="_row_auto" style={{marginLeft: -10, marginRight: -20}}>
                <div className="_column_auto" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid'}}>
                    <div style={{padding: 20}}>
                        <p>Total pembayaran bulan <span className="_capitalize">{filter_bulan}</span> </p>
                        <h1 className="_roboto _text_overflow _push_t_t">{convertToRupiah(data_pembayaran_bulan)}</h1>
                    </div>
                </div>
                <div className="_column_auto" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid'}}>
                    <div style={{padding: 20}}>
                        <p>Total tahun ajaran {filter_tahun} 
                            
                        </p>
                        <h1 className="_roboto _text_overflow _push_t_t">{convertToRupiah(data_pembayaran_tahun)}</h1>
                    </div>
                </div>
            </div>

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_overflow_x _push_t_d">
                <table className="_table" style={{minWidth: 3000}}>
                    <thead>
                        <tr>
                            <th rowSpan="2" style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th rowSpan="2">NIS</th>
                            <th rowSpan="2">Nama</th>
                            <th rowSpan="2">Kelas</th>
                            <th rowSpan="2">SPP</th>
                            <th colspan="12">Bulan</th>
                            <th rowSpan="2">Tahun</th>
                            <th rowSpan="2">
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>Juli</th>
                            <th>Agustus</th>
                            <th>September</th>
                            <th>Oktober</th>
                            <th>November</th>
                            <th>Desember</th>
                            <th>Januari</th>
                            <th>Februari</th>
                            <th>Maret</th>
                            <th>April</th>
                            <th>Mei</th>
                            <th>Juni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.list.length > 0 ? 
                                data.list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {/* <td>
                                            <a href={API_SERVER + '/' + item.path + '/' + item.file} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                        </td> */}
                                        <td>{decode(item.nis)}</td>
                                        <td>{decode(item.nama)}</td>
                                        <td>{decode(item.kelas)}</td>
                                        <td>{decode(convertToRupiah(item.harga))}</td>
                                        <td style={{backgroundColor: MONTH === 7 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.juli === 'juli' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 8 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.agustus === 'agustus' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 9 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.september === 'september' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 10 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.oktober === 'oktober' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 11 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.november === 'november' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 12 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.desember === 'desember' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 1 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.januari === 'januari' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 2 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.februari === 'februari' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 3 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.maret === 'maret' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 4 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.april === 'april' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 5 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.mei === 'mei' ? <span className="_badge_green">Lunas</span> : '-')}</td> 
                                        <td style={{backgroundColor: MONTH === 6 ? 'rgba(0,0,0,0.026)' : null}}>{decode(item.juni === 'juni' ? <span className="_badge_green">Lunas</span> : '-')}</td>
                                        <td>{decode(item.tahun)}</td>
                                        <td>
                                            <div className="_right_text _text_overflow">
                                                {/* <div onClick={() => {
                                                    // set_path_client(item.path)
                                                    set_bamboo_delete(item.bamboo)
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Delete
                                                </div> */}
                                                <div onClick={() => {
                                                    // set_path_client(item.path)
                                                    set_bamboo_update(item.bamboo)
                                                    // update state -------------------------
                                                    set_test(item.kode)
                                                    set_nis(item.nis)
                                                    set_nama(item.nama)
                                                    set_kelas(item.kelas)
                                                    set_harga(item.harga)
                                                    set_bulan(item.bulan)
                                                    set_tahun(item.tahun)
                                                    set_response(JSON.parse(item.response))
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Detail
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))

                            :
                                data &&
                                <tr>
                                    <td colSpan="10">Belum Ada Data</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}
            
            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;